export const REFRESH_ERROR = "Une erreur est survenue lors du rafraîchissement automatique.";



// WEBPACK FOOTER //
// ./src/errors/autoRefresh.js